import type { UserId_Schema, UserPublicInfo_Schema, UserStanding_Schema } from "@/services/user/userSchema";
import type { z } from "zod";

export type UserId = z.infer<typeof UserId_Schema>;
export type UserToken = string;

export type User = {
  id: UserId;
  email: string;
  isEmailVerified: boolean;
  name: string;
  avatar: string | null;
  showPrices: boolean;
  type: AccountType;
  role: Role;
  rights: Right[];
  token: UserToken;
};

export type UserPublicInfo = z.infer<typeof UserPublicInfo_Schema>;
export type UserStanding = z.infer<typeof UserStanding_Schema>;

export enum AccountType {
  Common = "common",
  Facebook = "facebook",
  Google = "google",
}

export enum Role {
  Admin = "admin",
  Collector = "collector",
}

// There are more, but the FE doesn't use them. Feel free to add them if needed.
export enum Right {
  Database2_0 = "database",
  YearInReview = "year-in-review", // This right is not in database. Used here to hide "year in review" page.
  PokemonExpert = "expert_admin_unpublish",
}
